if (!customElements.get('configurator-length')) {
  class ConfiguratorLength extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    /**
     * @param {ConfiguratorLengthEvent} event 
     */
    handleUpdate(event) {
      if(event.detail.length == 1 && event.detail.unit == 'mm') return;
      this.innerHTML = event.detail.length + event.detail.unit;
    }

    disconnectedCallback() {
      document.removeEventListener("configurator-length:update", this.handleUpdateRef);
    }

    connectedCallback() {
      document.addEventListener("configurator-length:update", this.handleUpdateRef);
    }
  }

  customElements.define('configurator-length', ConfiguratorLength);
}